module.exports = __webpack_public_path__ + "static/img/gopay-logo.f88c92a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gopay/gopay-logo.svg
// module id = u7vA
// module chunks = 1